// ─── ЦЕНА МАСТЕР-КЛАССА ДЛЯ КЛИЕНТА ──────────────────────────────────────────
// 26.09 (владелец, скрин сводки ОО за 19.09): «добавлены мастер-классы, уже после
// игры, а в расчёте (первый блок с деньгами) мастер-классы не появились».
//
// Формула жила одна — внутри GET /api/game-reports/calc-price, и её видела только
// форма отчёта оператора. Сводка ОО брала цену МК из УЖЕ СДАННОГО отчёта: если
// услуги добавили в бронь после сдачи, там навсегда оставался 0. Чтобы сводка могла
// посчитать то же самое, формула вынесена сюда и используется ОБОИМИ — иначе
// после первой же правки прайса форма и сводка показали бы разные числа.
//
// Правило (как было в calc-price): база + доплата за каждого игрока сверх порога.
// Порог null/0 = доплата с первого игрока.

export interface McPriceRow {
  base_price?: number | null;
  threshold?: number | null;
  extra_per_player?: number | null;
}

/** Цена одного МК для клиента при данном числе игроков. */
export function mcClientPrice(p: McPriceRow, players: number): number {
  let v = Number(p.base_price) || 0;
  const th = Number(p.threshold) || 0;
  const n = Number(players) || 0;
  if (n > th) v += (n - th) * (Number(p.extra_per_player) || 0);
  return v;
}

/** Сумма по нескольким МК брони. */
export function mcClientTotal(rows: McPriceRow[], players: number): number {
  let s = 0;
  for (const r of rows || []) s += mcClientPrice(r, players);
  return s;
}
